// extracted by mini-css-extract-plugin
export default {"styles":"styles___PAwP2","icon":"icon___Vu52o"};